import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import type { inferInput } from '@trpc/tanstack-react-query'
import { Select } from 'antd'
import { useDebouncedValue } from '@/hooks/use-debounced-value.ts'
import { useTRPC } from '@/trpc/react.ts'

export function FinanceSelect({
  kind,
  purpose,
  value,
  onChange,
  organizationId,
  disabled,
  id
}: {
  purpose: inferInput<ReturnType<typeof useTRPC>['bill']['directoryOptions']>['purpose']
  kind: 'organization' | 'customer' | 'payee' | 'member' | 'business' | 'site' | 'expenseBusiness'
  value?: number
  onChange?: (id: number | undefined) => void
  organizationId?: number
  disabled?: boolean
  id?: string
}) {
  const trpc = useTRPC(),
    [keyword, setKeyword] = useState('')
  const search = useDebouncedValue(keyword)
  const query = useQuery(
    trpc.bill.directoryOptions.queryOptions({ purpose, kind, keyword: search, selectedId: value, organizationId })
  )
  return (
    <Select
      id={id}
      value={value}
      onChange={onChange}
      disabled={disabled}
      allowClear
      showSearch={{ filterOption: false, onSearch: setKeyword }}
      loading={query.isFetching}
      options={query.data?.map((v) => ({
        value: v.id,
        label: kind === 'payee' || kind === 'expenseBusiness' ? v.name : `${v.name} (#${v.id})`
      }))}
      placeholder="输入名称搜索"
      notFoundContent={query.isError ? query.error.message : undefined}
    />
  )
}
